import type { ComponentProps } from "react"

export default function PropertyUndeveloped(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M10.6666 2.66675H14.6666V5.33341H10.6666V2.66675ZM10.6666 26.6667H14.6666V29.3334H10.6666V26.6667ZM2.66663 10.6667H5.33329V14.6667H2.66663V10.6667ZM2.66663 17.3334H5.33329V21.3334H2.66663V17.3334ZM2.66663 4.00008V8.00008H5.33329V5.33341H7.99996V2.66675H3.99996C3.64634 2.66675 3.3072 2.80722 3.05715 3.05727C2.8071 3.30732 2.66663 3.64646 2.66663 4.00008ZM5.33329 24.0001H2.66663V28.0001C2.66663 28.3537 2.8071 28.6928 3.05715 28.9429C3.3072 29.1929 3.64634 29.3334 3.99996 29.3334H7.99996V26.6667H5.33329V24.0001Z"
        fill={fill}
      />
      <path
        d="M21.3333 2.66675H17.3333V5.33341H21.3333V2.66675ZM21.3333 26.6667H17.3333V29.3334H21.3333V26.6667ZM29.3333 10.6667H26.6666V14.6667H29.3333V10.6667ZM29.3333 17.3334H26.6666V21.3334H29.3333V17.3334ZM29.3333 4.00008V8.00008H26.6666V5.33341H24V2.66675H28C28.3536 2.66675 28.6927 2.80722 28.9428 3.05727C29.1928 3.30732 29.3333 3.64646 29.3333 4.00008ZM26.6666 24.0001H29.3333V28.0001C29.3333 28.3537 29.1928 28.6928 28.9428 28.9429C28.6927 29.1929 28.3536 29.3334 28 29.3334H24V26.6667H26.6666V24.0001Z"
        fill={fill}
      />
    </svg>
  )
}
